import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { isMobile } from "react-device-detect";

class SectionTitle extends Component {
	render() {
		const { title, to = "/", className } = this.props;
		if (isMobile) {
			return (
				<h2 className={classNames(className)}>
					<Link to={to}>{title}</Link>
				</h2>
			);
		} else {
			return (
				<h3 className={classNames("ic", className)}>
					<Link to={to}>{title}</Link>
				</h3>
			);
		}
	}
}
export default SectionTitle;
